import * as i0 from '@angular/core';
import { Directive, Input, HostBinding, NgModule } from '@angular/core';

/**
 * Abstraction over `tabindex`
 */
class TuiFocusableDirective {
    constructor() {
        /**
         * Element can be focused with keyboard
         */
        this.focusable = true;
    }
    get tabIndex() {
        return this.focusable ? 0 : -1;
    }
}
TuiFocusableDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiFocusableDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
TuiFocusableDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "12.2.17", type: TuiFocusableDirective, selector: "[tuiFocusable]", inputs: { focusable: ["tuiFocusable", "focusable"] }, host: { properties: { "tabIndex": "this.tabIndex" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiFocusableDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[tuiFocusable]',
                }]
        }], propDecorators: { focusable: [{
                type: Input,
                args: ['tuiFocusable']
            }], tabIndex: [{
                type: HostBinding,
                args: ['tabIndex']
            }] } });

class TuiFocusableModule {
}
TuiFocusableModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiFocusableModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
TuiFocusableModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiFocusableModule, declarations: [TuiFocusableDirective], exports: [TuiFocusableDirective] });
TuiFocusableModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiFocusableModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiFocusableModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [TuiFocusableDirective],
                    exports: [TuiFocusableDirective],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { TuiFocusableDirective, TuiFocusableModule };
